import { render, staticRenderFns } from "./CompanyBasicDetails.vue?vue&type=template&id=a0479f2c&scoped=true&"
import script from "./CompanyBasicDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyBasicDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0479f2c",
  null
  
)

export default component.exports